/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nice_Happy_Duck_HeartInputs */

const fr_nice_happy_duck_heart = /** @type {(inputs: Nice_Happy_Duck_HeartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

/**

* @param {Nice_Happy_Duck_HeartInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const nice_happy_duck_heart = /** @type {((inputs?: Nice_Happy_Duck_HeartInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nice_Happy_Duck_HeartInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_nice_happy_duck_heart(inputs)
});